import Typography from "../Typography";
import { useDrawerContext } from "./DrawerContext";

type DrawerHeaderTitleProps = {
  title: string;
  id?: string;
};

const DrawerHeaderTitle = ({ title }: DrawerHeaderTitleProps) => {
  const titleId = useDrawerContext();

  return (
    <Typography tag="h4" variant="p-t4" id={titleId}>
      {title}
    </Typography>
  );
};

DrawerHeaderTitle.displayName = "DS.Drawer.HeaderTitle";

export default DrawerHeaderTitle;
